module.exports = vue;